import { useMemo, useState } from 'react';

import { KnowledgeArticle } from './types';

export function useKnowledgeSearch(articles: KnowledgeArticle[]) {
  const [query, setQuery] = useState('');
  const normalizedQuery = query.trim().toLowerCase();

  const results = useMemo(() => {
    if (!normalizedQuery) {
      return [];
    }

    return articles.filter((article) => {
      const haystack = `${article.title} ${article.summary} ${article.bodyHtml}`.toLowerCase();
      return haystack.includes(normalizedQuery);
    });
  }, [articles, normalizedQuery]);

  return {
    query,
    setQuery,
    results,
    hasQuery: normalizedQuery.length > 0,
  };
}
